export const PRODUCT_SYSTEMS_CATALOG_TEST_ID = {
  title: 'productSystemsCatalogTitle',
};
